__webpack_require__.p = "/Computer-Graphics/";